import { Link } from "react-router-dom";
import { Meta } from "../Cards";
import { Reveal } from "../Reveal";
import { catLabel } from "../../lib/api";

const Num = ({ n }) => (
  <span className="wordmark text-pink text-4xl leading-[0.75] pb-[0.15em] whitespace-nowrap">{String(n).padStart(2, "0")}</span>
);

const LeadStory = ({ a }) => (
  <Link to={`/article/${a.slug}`} className="group block" data-testid="lead-story">
    <div className="img-zoom relative overflow-hidden aspect-[4/5] bg-blush">
      <img src={a.cover} alt={a.title} className="h-full w-full object-cover" />
      <span className="absolute top-4 left-4 kicker bg-hot text-ink border border-ink px-2 py-1">Lead story</span>
    </div>
    <div className="mt-5"><Meta a={a} /></div>
    <h3 className="display text-[clamp(2.5rem,4.6vw,4.75rem)] leading-[0.88] mt-3 group-hover:text-rose transition-colors">{a.title}</h3>
    {a.dek && <p className="font-serif italic text-lg sm:text-xl text-ink/75 mt-3 max-w-xl leading-snug">{a.dek}</p>}
  </Link>
);

const PortraitStory = ({ a, i }) => (
  <Link to={`/article/${a.slug}`} className="group block" data-testid={`lead-pair-${i}`}>
    <div className="img-zoom overflow-hidden aspect-[3/4] bg-blush">
      <img src={a.cover} alt={a.title} loading="lazy" className="h-full w-full object-cover" />
    </div>
    <div className="mt-4"><Meta a={a} /></div>
    <h3 className="display text-3xl mt-2 group-hover:text-rose transition-colors">{a.title}</h3>
  </Link>
);

const EditList = ({ items }) => {
  if (!items.length) return null;
  return (
  <div>
    <p className="kicker bg-ink text-cream inline-block px-2 py-1 mb-2">The edit</p>
    <ol>
      {items.map((a, i) => (
        <li key={a.slug} className="border-t border-ink/20 first:border-t-0">
          <Link to={`/article/${a.slug}`} className="group grid grid-cols-[76px_1fr] gap-2 py-4" data-testid={`edit-item-${i}`}>
            <Num n={i + 1} />
            <div>
              <p className="kicker text-rose">{catLabel(a.category)}</p>
              <h4 className="display text-2xl mt-1 group-hover:text-rose transition-colors">{a.title}</h4>
            </div>
          </Link>
        </li>
      ))}
    </ol>
  </div>
  );
};

export const LeadGrid = ({ lead, pair = [], edit = [], heading = true }) => {
  if (!lead) return null;
  return (
    <section className={`max-w-[1440px] mx-auto px-5 sm:px-10 pb-16 sm:pb-24 ${heading ? "pt-16 sm:pt-24" : "pt-4"}`} data-testid="lead-grid">
      {heading && (
        <div className="flex items-end justify-between gap-4 border-b-[3px] border-ink pb-3 mb-8">
          <h2 className="display text-6xl sm:text-8xl">Now<span className="text-pink">.</span></h2>
          <p className="kicker text-ink/70 text-right">What everyone is reading</p>
        </div>
      )}
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-0">
        <Reveal className="lg:col-span-6 lg:pr-8"><LeadStory a={lead} /></Reveal>
        <div className="lg:col-span-3 lg:border-l-2 lg:border-ink lg:px-8 grid sm:grid-cols-2 lg:grid-cols-1 gap-10 content-start">
          {pair.map((a, i) => (
            <Reveal key={a.slug} delay={0.1 * (i + 1)}><PortraitStory a={a} i={i} /></Reveal>
          ))}
        </div>
        <Reveal className="lg:col-span-3 lg:border-l-2 lg:border-ink lg:pl-8" delay={0.2}>
          <EditList items={edit} />
        </Reveal>
      </div>
    </section>
  );
};
